import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { NavService } from '../../core/nav.service';
import { ObjectObservable } from '../../shared/base/object-observable';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-lecture-edit',
  templateUrl: './lecture-edit.component.html',
  styleUrls: ['./lecture-edit.component.scss']
})
export class LectureEditComponent implements OnInit {
  lectureObservable: ObjectObservable<Lecture>;
  constructor(private snackBar: MatSnackBar, private route: ActivatedRoute, private nav: NavService) { }
  private AppConfig: any;

  ngOnInit() {
    this.initNav();
    this.route.parent.data.subscribe((data: { lecture: ObjectObservable<Lecture> }) => this.lectureObservable = data.lecture);
    this.AppConfig = APPCONFIG;
  }

  async onSubmit(value: Lecture) {
    try {
      delete value.$exists;
      delete value.$key;
      await this.lectureObservable.update(value);
    } catch (e) {
      this.handleError(e);
    }
  }

  private initNav(): void {
    this.nav.actions = [
      { text: '강의로 돌아가기', commands: ['.'], route: this.route.parent }
    ];
  }

  private handleError(error: any) {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, null, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-edit/lecture-edit.component.ts